// extracted by mini-css-extract-plugin
module.exports = {"vehiclePreviewGrid":"vehicle-preview_vehiclePreviewGrid__1M0y8","withEdit":"vehicle-preview_withEdit__5IaLz","overflowText":"vehicle-preview_overflowText__UWhwP"};